<template>
  <div class="survey-detail-container">
    <div class="survey-detail-header">
      <div class="header-left">
        <div class="survey-detail-title">
          <div class="survey-detail-title-text">Details</div>
        </div>
        <div class="survey-detail-name">
          <div class="survey-detail-name-text" v-if="recording.name">
            {{ recording.name }}
          </div>
          <div class="survey-detail-name-text" v-else>No Name</div>
        </div>
      </div>

      <div class="header-right">
        <div class="survey-detail-buttons">
          <b-button
            class="survey-detail-button"
            v-if="recording.status === 1"
            v-on:click="archiveSurvey"
          >
            Archive
          </b-button>
          <b-button
            class="survey-detail-button"
            v-if="recording.status === 2"
            v-on:click="publishSurvey"
          >
            Reopen
          </b-button>
        </div>
      </div>
    </div>

    <hr class="divider" />
    <div class="survey-detail-body">
      <div class="survey-detail-description">
        <div class="survey-detail-subtitle">
          Description
        </div>
        <div class="survey-detail-description-text" v-if="recording.description">
          {{ recording.description }}
        </div>
        <div class="survey-detail-description-text" v-else>
          This survey has no description.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Template from "../../../Firestore/Template.js";
import Response from "../../../Firestore/Response.js";

export default {
  name: "details",
  components: {

  },
  props: {
    detail: {
      type: Object,
    },
    recording: {
      type: Object
    }
  },
  data() {
    return {
      recordingObj: []
    };
  },
  methods: {
    toggleQuestion(index) {
      if (this.openQuestions.includes(index)) {
        this.openQuestions = this.openQuestions.filter(i => i !== index);
      } else {
        this.openQuestions.push(index);
      }
    },
    publishSurvey() {
      Response.assignSurveyToAll(this.survey.sID, this.survey.gameID)
        .then(() => {
          this.survey.status = 1;
        })
        .catch(e => console.log(e));
    },
    archiveSurvey() {
      Template.setSurveyStatus(this.survey.sID, 2)
        .then(() => {
          this.survey.status = 2;
        })
        .catch(e => console.log(e));
    },
  }
};
</script>

<style scoped>
.survey-detail-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  width: 100%;
}

.survey-detail-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 10%;
  min-height:10%;
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
}

.header-left {
  margin-left: 5%;
  display: flex;
  flex-direction: row;
}
.header-right {
  margin-right: 2.5%;
  display: flex;
  flex-direction: row;
}
.survey-detail-title {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  /* width: 50%; */
  align-items: center;
  justify-content: center;
}
.survey-detail-title-text {
  font-weight: bold;
  font-size: 24px;
  line-height: 46px;
  color: #fc7727;
  vertical-align: bottom;
}
.survey-detail-name {
  font-style: italic;
  font-weight: bold;
  margin-left: 10px;
  margin-top: 15px;
  color: #909090;
  vertical-align: bottom;
}
.survey-detail-buttons {
  float: right;
}
.survey-detail-button{
  background-color: #fc7727 !important;
  color: #fff;
  border: none;
  border-radius: 10px !important;
  padding: 0.25rem 0.5rem;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
}
.survey-detail-button:hover{
  background-color: #ff8e4d !important;
}
.divider {
  border: 1px solid #c2c2c2;
  width: 95%;
  margin: 0 auto;
}
.survey-detail-subtitle {
  font-size: 20px;
  line-height: 46px;
  color: #fc7727;
  margin-top: 5px;
}
.survey-detail-body {
  margin-left: 5%;
  margin-right: 5%;
}

.survey-detail-description-text {
  color: #bebebe;
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
}

.tag-capsule {
  background-color: #db3360;
  color: white;
  border-radius: 10px;
  padding: 5px 10px;
  margin-right: 8px;
  margin-bottom: 5px;
  box-shadow: 0px 4px 10px rgba(219, 51, 96, 0.3);
}
.question-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  width: 100%;
  margin-bottom: 10px;
  margin-top: 10px;
  cursor: pointer;

}
.qheader-left {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  width: 70%;
  align-items: center;
  justify-content: flex-start;
}
.qheader-right {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  width: 30%;
  align-items: center;
  justify-content: flex-end;
}
.question-title {
  margin-left: 5px;
}
.question-type {
  font-style: italic;
  margin-right: 10px;
  color: #bebebe;
  vertical-align: bottom;
}

.question-body{
  margin-left: 20px;
  margin-bottom: 5px;
}

.question-content-container {
  display: flex;
  flex-direction: column;
}

.question-content {
  display: flex;
  align-items: flex-start;
  margin-left: 20px; /* Adjust the margin as needed */
}

.question-content::before {
  /* content: '•'; */
  margin-right: 5px; /* Adjust the margin as needed */
}
</style>



// WEBPACK FOOTER //
// src/components/game-detail/Recordings/RecordingDetails.vue